import { render, staticRenderFns } from "./SidebarLogo.vue?vue&type=template&id=1c145fb7&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"
import style0 from "./SidebarLogo.vue?vue&type=style&index=0&id=1c145fb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c145fb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c145fb7')) {
      api.createRecord('1c145fb7', component.options)
    } else {
      api.reload('1c145fb7', component.options)
    }
    module.hot.accept("./SidebarLogo.vue?vue&type=template&id=1c145fb7&scoped=true", function () {
      api.rerender('1c145fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/SidebarLogo.vue"
export default component.exports